<template>
  <b-modal
    :id="id"
    :ok-title="okTitle"
    content-class="start-modal"
    @hidden="propagateClose"
    header-bg-variant="dark"
    header-text-variant="light"
    header-border-variant="dark"
    body-bg-variant="dark"
    body-text-variant="light"
    footer-bg-variant="dark"
    footer-border-variant="dark"
    ok-variant="secondary"
    scrollable
    hide-header-close
    ok-only
    centered
  >
    <template v-slot:modal-header>
      <b-img :src="whenceLogo" alt="Whence" class="start-logo" />
    </template>
    <p><strong>Can you guess where on earth you are from a satellite image?</strong> Whence drops you in a random location, zoomed in as closely as possible on Google Maps.</p>
    <p><strong>Guess the location by clicking on the in-set world map.</strong> Zoom out to get more clues. The closer you are to the target and the fewer zooms you make, the better you score. The game ends after {{roundsPerGame}} locations.</p>
    <p>Note: Doesn't currently work well on small screens such as mobile phones.</p>
  </b-modal>
</template>

<script>
import { BImg, BModal } from 'bootstrap-vue'
import { GAME_PHASE, ROUNDS_PER_GAME } from '../../constants/whence.js'
import whenceLogo from '../../img/whence/whence-logo-plain.png'

export default {
  props: {
    id: {
      type: String
    },
    gamePhase: {
      type: String,
      required: true
    },
  },
  data: function() {
    return {
      roundsPerGame: ROUNDS_PER_GAME,
      whenceLogo: whenceLogo
    };
  },
  computed: {
    okTitle() {
      return this.gamePhase == GAME_PHASE.unstarted ? 'Start Game' : 'Resume Game';
    }
  },
  methods: {
    propagateClose(evt) {
      this.$emit('close');
    },
  },
  components: {
    'b-img': BImg,
    'b-modal': BModal
  }
}
</script>

<style>
.start-modal {
  border: 2px white solid;
}
.start-modal button {
  color: #fdcd25;
  font-weight: bold;
}
.start-logo {
  width: 60%;
  margin: auto;
}
</style>
